/* eslint-disable @typescript-eslint/naming-convention */
import { Callout } from '@dev-spendesk/grapes';
import cx from 'classnames';
import { type ReactElement, type ReactNode } from 'react';

import { useTranslation } from 'common/hooks/useTranslation';

export type SimpleItem = {
  error?: React.JSX.Element;
  deleted?: boolean;
  valueDeleted?: boolean;
  value: string | ReactElement;
  values?: never;
  component?: never;
  className?: string;
} & (
  | {
      label: string;
      key?: never;
    }
  | {
      label: ReactNode;
      key: string;
    }
);

export const SimplePanelItem = ({
  item,
  className,
}: {
  item: SimpleItem;
  className?: string;
}) => {
  const { t } = useTranslation('global');
  const isDeleted = item.deleted || item.valueDeleted;

  const deletedValueLabel =
    typeof item.value === 'string'
      ? item.value
      : // @ts-expect-error - checking for props on ReactNode
        item.value?.props?.translationKey;
  return (
    <>
      <li
        key={typeof item.key === 'string' ? item.key : item.label}
        className={cx(
          'body-m my-8 flex h-full w-full flex-row items-center',
          className,
        )}
      >
        <div className="flex w-full flex-col space-y-4">
          <div className="flex w-full flex-row items-center gap-24">
            {typeof item.label === 'string' ? (
              <span
                className={cx('text-content-secondary-bg-primary flex-1', {
                  'line-through': item.deleted,
                })}
              >
                {item.label}
              </span>
            ) : (
              item.label
            )}
            <span
              className={cx('w-1/2 truncate text-left', {
                'text-content-alert-default font-semibold': item.error,
                'text-content-secondary-bg-primary': isDeleted,
                'text-content-primary': !(item.error || item.valueDeleted),
                'line-through': isDeleted,
              })}
              title={typeof item.value === 'string' ? item.value : ''}
            >
              {item.value}
            </span>
          </div>

          {isDeleted && (
            <Callout
              variant="warning"
              className="!my-8"
              title={t('common.panelItemsSection.removed', {
                item: item.deleted ? item.label : deletedValueLabel,
              })}
            />
          )}
        </div>
      </li>
      {item.error && (
        <div className="body-m -mr-8 -ml-8 px-8">{item.error}</div>
      )}
    </>
  );
};
